import { render, staticRenderFns } from "./smrz.vue?vue&type=template&id=471af2ea&scoped=true&"
import script from "./smrz.vue?vue&type=script&lang=js&"
export * from "./smrz.vue?vue&type=script&lang=js&"
import style0 from "./smrz.vue?vue&type=style&index=0&id=471af2ea&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "471af2ea",
  null
  
)

export default component.exports